import type { OnboardingRequirement } from '@onefootprint/request-types';

/** A requirement neither idv2 nor legacy idv can render. The root error boundary shows the screen and reports it. */
class UnsupportedRequirementError extends Error {
  requirementKind: OnboardingRequirement['kind'];
  orgId: string;

  constructor(requirementKind: OnboardingRequirement['kind'], orgId: string) {
    super('No screen renders this requirement kind');
    this.name = 'UnsupportedRequirementError';
    this.requirementKind = requirementKind;
    this.orgId = orgId;
  }
}

export { UnsupportedRequirementError };
